import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider, createBrowserRouter } from "react-router";

import App from "./routes/App/App";

import "./index.css";

const router = createBrowserRouter([
	{
		path: "/:period/aluno/:ra",
		element: <App />,
	},
	{
		path: "*",
		loader: () => {
			window.location.href = "https://lsb.edu.br/";
			return null;
		},
	},
]);

ReactDOM.createRoot(document.getElementById("root")).render(
	<React.StrictMode>
		<RouterProvider router={router} />
	</React.StrictMode>
);
